// src/components/FacultyList.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './FacultyList.css';

const FacultyList = () => {
  const [faculty, setFaculty] = useState([]);
  const [sortedFaculty, setSortedFaculty] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });
  const [searchQuery, setSearchQuery] = useState('');
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedFaculty, setSelectedFaculty] = useState(null);
  const [newPassword, setNewPassword] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    fetchFaculty();
  }, []);

  useEffect(() => {
    setSortedFaculty(faculty);
  }, [faculty]);

  const fetchFaculty = async () => {
    try {
      const authToken = localStorage.getItem('authToken');
      const { data } = await axios.get(
        'http://121.52.154.120:3001/api/faculty-directory',
        { headers: { Authorization: `Bearer ${authToken}` } }
      );
      setFaculty(data);
      setSortedFaculty(data);
      setError(null);
    } catch (err) {
      setError('Failed to retrieve faculty data. Please try again.');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this faculty member?')) {
      return;
    }
    try {
      const authToken = localStorage.getItem('authToken');
      await axios.delete(
        `http://121.52.154.120:3001/admin/faculty/${id}`,
        { headers: { Authorization: `Bearer ${authToken}` } }
      );
      setSuccessMessage('Faculty member deleted successfully.');
      fetchFaculty();
      // clear message after 3s
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (err) {
      console.error('Delete error →', err.response || err);
      setError(
        err.response?.status === 403
          ? 'You do not have permission to delete faculty.'
          : 'Failed to delete faculty member. Please try again.'
      );
    }
  };

  const handleUpdatePassword = async () => {
    if (!selectedFaculty || !newPassword.trim()) {
      return alert('Please enter a new password.');
    }
    try {
      const authToken = localStorage.getItem('authToken');
      await axios.post(
        'http://121.52.154.120:3001/admin/faculty/reset-password',
        { id: selectedFaculty.id, newPassword },
        { headers: { Authorization: `Bearer ${authToken}` } }
      );
      setSuccessMessage(`Password reset for ${selectedFaculty.name}.`);
      setShowModal(false);
      setNewPassword('');
      setSelectedFaculty(null);
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (err) {
      console.error('Password reset error →', err.response || err);
      setError(
        err.response?.status === 403
          ? 'You do not have permission to reset passwords.'
          : 'Failed to update password. Please try again.'
      );
    }
  };

  const stripPrefix = (name) =>
    name.replace(/^(Dr\.|Prof\.|Ms\.|Mr\.)\s*/i, '');

  const handleSearch = (e) => {
    const q = e.target.value.toLowerCase();
    setSearchQuery(q);
    setSortedFaculty(
      faculty.filter((m) =>
        stripPrefix(m.name).toLowerCase().includes(q) ||
        stripPrefix(m.username).toLowerCase().includes(q) ||
        m.department.toLowerCase().includes(q) ||
        m.designation.toLowerCase().includes(q)
      )
    );
  };

  const sortArray = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    const sorted = [...faculty].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'ascending' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'ascending' ? 1 : -1;
      return 0;
    });
    setSortConfig({ key, direction });
    setSortedFaculty(sorted);
  };

  return (
    <div className="faculty-list">
      <h2>Faculty List</h2>
      {error && <p className="error">{error}</p>}
      {successMessage && <p className="success">{successMessage}</p>}
      <div className="controls">
        <input
          type="text"
          placeholder="Search"
          value={searchQuery}
          onChange={handleSearch}
          className="search-input"
        />
        <button onClick={() => sortArray('name')}>Sort by Name</button>
        <button onClick={() => sortArray('username')}>Sort by Username</button>
        <button onClick={() => sortArray('department')}>Sort by Department</button>
        <button onClick={() => sortArray('designation')}>Sort by Designation</button>
      </div>
      <table>
        <thead>
          <tr>
            <th>ID</th><th>Username</th><th>Name</th>
            <th>Department</th><th>Designation</th>
            <th>Email</th><th>Phone Number</th><th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {sortedFaculty.map((m) => (
            <tr key={m.id}>
              <td>{m.id}</td>
              <td>{m.username}</td>
              <td>{stripPrefix(m.name)}</td>
              <td>{m.department}</td>
              <td>{m.designation}</td>
              <td>{m.email}</td>
              <td>{m.phoneNumber}</td>
              <td>
                <button onClick={() => handleDelete(m.id)}>Delete</button>
                <button onClick={() => {
                  setSelectedFaculty(m);
                  setShowModal(true);
                }}>
                  Reset Password
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <h3>Reset Password for {selectedFaculty.name}</h3>
            <input
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <div className="modal-actions">
              <button onClick={handleUpdatePassword}>Submit</button>
              <button onClick={() => setShowModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FacultyList;
